const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider // Recipes
        .state(
            'shop.recipes',
            {
                url: '/recipes?{pageNumber:int}&{sortBy}',
                resolve: {
                    categories: ['RecipeCategoriesService', recipeCategoriesService => recipeCategoriesService.getAll()],
                },
                views: {
                    'left-panel@shop': {
                        controller: ['RecipeCategoriesService', function (recipeCategoriesService) {
                            this.recipeCategoriesService = recipeCategoriesService;
                        }],
                        controllerAs: '$ctrl',
                        template: '<wow-recipe-navigation ng-if="!$breakpoints.isInSmallFormat" current-category="$ctrl.recipeCategoriesService.currentCategory"></wow-recipe-navigation>',
                    },
                },
                onExit: ['RecipeCategoriesService', (recipeCategoriesService) => {
                    recipeCategoriesService.resetCurrentCategory();
                }],
            },
        )
        .state('shop.recipes.recipenotfound', {
            url: '/recipenotfound',
            views: {
                'center-panel@shop': {
                    template: '<wow-error-page error-page="\'recipeNotFound\'"></wow-error-page>',
                },
            },
            data: {
                shouldGetMetadata: false,
            },
        })
        .state('shop.recipes.savedList', {
            url: '/mykeptrecipes',
            views: {
                'center-panel@shop': {
                    controller: ['$state', function ($state) {
                        this.$state = $state;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-recipe-list-tile-list
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-recipe-list-tile-list>
                    `,
                },
            },
        })
        .state('shop.recipes.noSavedRecipes', {
            url: '/nokeptrecipes',
        })
        .state('shop.recipes.category', {
            abstract: true,
            url: '/:category',
        })
        .state('shop.recipes.category.subCategory', {
            url: '/:subCategory',
            reloadOnSearch: false,
            onEnter: ['$stateParams', 'RecipeCategoriesService', function ($stateParams, recipeCategoriesService) {
                recipeCategoriesService.setCategoryByName($stateParams.category, $stateParams.subCategory);
            }],
            views: {
                'center-panel@shop': {
                    controller: ['$state', 'RecipeCategoriesService', function ($state, recipeCategoriesService) {
                        this.$state = $state;
                        this.recipeCategoriesService = recipeCategoriesService;
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-recipe-tile-list
                            current-category="$ctrl.recipeCategoriesService.currentCategory"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-recipe-tile-list>
                    `,
                },
            },
            data: {
                pageMetadata: [
                    '$state', 'PageMetadataService', 'RecipeCategoriesService', '$window', function ($state, pageMetadataService, recipeCategoryService, $window) {
                        const category = recipeCategoryService.getCategoryByName($state.params.category, $state.params.subCategory);
                        return pageMetadataService.getMetadata(
                            { name: category.aisle.Name }, false,
                            `/Shop/Recipes/${$state.params.category}/${$state.params.subCategory}`, 'RecipeCategory',
                            { canonical: $window.location.href },
                        );
                    },
                ],
            },
        })
        .state('shop.recipedetail', {
            url: '/recipedetail/{recipeId}/{recipeTitle}',
            resolve: {
                recipe: ['$stateParams', 'RecipeService', ($stateParams, recipeService) => recipeService.getRecipe($stateParams.recipeId)],
            },
            onEnter: ['$state', 'recipe', ($state, recipe) => {
                if (!recipe) {
                    this.$state.go('error.404', null, { location: 'replace' });
                }
            }],
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@shop.recipedetail': {
                    controller: [
                        'recipe', function (recipe) {
                            this.recipe = recipe;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-recipe-detail recipe="$ctrl.recipe"></wow-recipe-detail>',
                },
            },
            data: {
                pageMetadata: [
                    'RecipeService', 'PageMetadataService', 'config', '$stateParams', '$window',
                    function (recipeService, pageMetadataService, config, $stateParams, $window) {
                        if (!$stateParams.recipeId) {
                            return pageMetadataService.getMetadata(null, null, null, 'Recipe');
                        }

                        return recipeService.getRecipe($stateParams.recipeId).then(details => (details
                            ? pageMetadataService.getMetadata({ name: details.Title, site: config.SiteShortName }, null, '/Shop/Recipe', 'Recipe', { canonical: `${$window.location.origin}/shop/recipedetail/${details.RecipeId}/${details.UrlFriendlyTitle}` })
                            : pageMetadataService.getMetadata(null, null, null, 'Recipe')));
                    },
                ],
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/recipes.js